import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController } from 'ionic-angular';


@Component({
  selector: 'image-viewer',
  templateUrl: 'image-viewer.html'
})
export class ImageViewerModal {

  imageContent:string;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public actionSheetCtrl: ActionSheetController,) {
        this.imageContent = this.navParams.get('imageContent');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/image-viewer/image-viewer.component.ts